import React from 'react'
import PropTypes from 'prop-types';

class FileUploader extends React.Component {
  static propTypes = {
    accept: PropTypes.string.isRequired,
    handleFileChange: PropTypes.func.isRequired,
    indicateFileUploadInProgress: PropTypes.func,
    indicateFileUploadComplete: PropTypes.func,
    inputRef: PropTypes.func
  };

  constructor (props) {
    super(props)
    this.handleFile = this.handleFile.bind(this)
  }

  handleFile (e) {
    if (this.props.indicateFileUploadInProgress) {
      this.props.indicateFileUploadInProgress()
    }
    // eslint-disable-next-line no-undef
    var reader = new FileReader()
    var file = e.target.files[0]

    if (!file) return
    reader.onload = function (img) {
      // ReactDom.findDOMNode(this.refs.in).value = ''
      this.props.handleFileChange(img.target.result)
      if (this.props.indicateFileUploadComplete) {
        this.props.indicateFileUploadComplete()
      }
    }.bind(this)
    reader.readAsDataURL(file)
  }

  render () {
    return <input ref={this.props.inputRef} type='file' accept={this.props.accept} onChange={this.handleFile} />
  }
}

export default FileUploader
